import CoreBreadcrumbs, {
    type BreadcrumbsProps as CoreBreadcrumbsProps,
} from '@ovpn/ui/breadcrumbs';

import { boxed } from '@sso/shared/hocs';

import Anchor, { type AnchorProps } from './Anchor';

type Breadcrumb = Omit<AnchorProps, 'children'> & { name: string };

type BreadcrumbsProps = Omit<CoreBreadcrumbsProps, 'children'> & {
    breadcrumbs: Breadcrumb[];
};

function Breadcrumbs({ breadcrumbs, ...props }: BreadcrumbsProps) {
    return (
        <CoreBreadcrumbs {...props}>
            {breadcrumbs.map(({ name, id, ...breadcrumb }) => (
                <Anchor {...breadcrumb} key={id} id={id}>
                    {name}
                </Anchor>
            ))}
        </CoreBreadcrumbs>
    );
}

export default boxed(Breadcrumbs);
